import { render, staticRenderFns } from "./getNewPhoneNumber.vue?vue&type=template&id=9cfa6c66"
import script from "./getNewPhoneNumber.vue?vue&type=script&lang=js"
export * from "./getNewPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports